import { createSelector } from '@reduxjs/toolkit';
import { enFlowUnit } from 'application/project/api/Project';
import { selectProjectState } from 'projectRedux/store';

export const selectActiveProject = createSelector(
  (state: any) => selectProjectState(state),
  (projectSate) => projectSate?.activeProject
);

export const selectFlowUnitID = createSelector(
  (state: any) => selectProjectState(state).activeProject?.flowUnitID,
  (flowUnitID) => flowUnitID ?? enFlowUnit.m3_h
);
